// Adapted from https://github.com/Azure-Samples/ms-identity-b2c-javascript-spa
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
import {useMsalStore} from '@/store/msal'

const msalStore = useMsalStore()
const susiAuthority = 'https://' + msalStore.authorityDomain + '/pattanb2c.onmicrosoft.com/' + msalStore.policy

const b2cPolicies = {
    names: {
        signUpSignIn: msalStore.policy,
        editProfile: msalStore.policy
    },
    authorities: {
        signUpSignIn: {
            authority: susiAuthority,
        },
        editProfile: {
            authority: susiAuthority,
        }
    },
    authorityDomain: msalStore.authorityDomain
}

export default b2cPolicies
